import { CheckboxGroupProps } from "antd/es/checkbox";
import { CheckboxProps as AntCheckboxProps, Flex } from "antd";
import { SVGs } from "../assets";
import Text from "./text";
import React from "react";

interface CheckboxProps extends AntCheckboxProps {
  postAddon?: React.ReactNode | null;
  label?: string;
}

interface GroupProps extends Omit<CheckboxGroupProps, "options"> {
  options: CheckboxProps[];
  vertical?: boolean;
  max?: number;
  postAddon?: (option: any) => React.ReactNode;
}

const Checkbox = ({
  label,
  checked,
  onChange = () => {},
  disabled,
  postAddon = null,
  className = "",
  ...props
}: CheckboxProps) => {
  return (
    <Flex
      gap={"1rem"}
      align="center"
      className={`${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"} ${className}`}
      onClick={(e) =>
        !disabled && onChange({ ...e, target: { checked: !checked } } as any)
      }
      {...props}
    >
      <img
        alt=""
        className="h-[2.2rem] w-[2.2rem]"
        src={checked ? SVGs.checkboxActive : SVGs.ringOutlined}
      />
      {label && <Text weight="600" color="secondary" children={label} />}
      {postAddon}
    </Flex>
  );
};

const Group = ({
  max,
  style,
  value = [],
  options = [],
  vertical = false,
  onChange = () => {},
  postAddon = () => null,
  ...props
}: GroupProps) => {
  return (
    <Flex
      {...props}
      gap={"1rem"}
      vertical={vertical}
      children={React.Children.toArray(
        options.map((option) => {
          const checked = value.includes(option.value);
          return (
            <Checkbox
              {...option}
              checked={checked}
              disabled={
                !!option.disabled || (!!max && value.length >= max && !checked)
              }
              postAddon={postAddon(option)}
              onChange={() =>
                onChange(
                  checked
                    ? value.filter((_) => _ !== option.value)
                    : [...value, option.value]
                )
              }
            />
          );
        })
      )}
    />
  );
};

Checkbox.Group = Group;
export default Checkbox;
